import client from '../../../common/client';

export const GET_MEMBER_SESSIONS = 'GET_MEMBER_SESSIONS';
export const CANCEL_MS_SESSION_FOR_USER = 'CANCEL_MS_SESSION_FOR_USER';
export const CANCEL_TATHATA_SESSION_FOR_USER = 'CANCEL_TATHATA_SESSION_FOR_USER';

export const getMemberSessions = userId => {
  return {
    promise: client.get(`users/${userId}/sessions`),
    type: GET_MEMBER_SESSIONS,
  };
};

export const cancelMovementSpecialistSession = (userId, sessionId) => {
  return {
    promise: client.patch(`users/${userId}/sessions/${sessionId}/cancel`),
    type: CANCEL_MS_SESSION_FOR_USER,
    sessionId,
  };
};

export const cancelTathataFollowUpSession = (userId, sessionId) => {
  return {
    promise: client.patch(`users/${userId}/tathata-follow-ups/${sessionId}/cancel`),
    type: CANCEL_TATHATA_SESSION_FOR_USER,
    sessionId,
  };
};



// WEBPACK FOOTER //
// ./src/subscription/sessions/redux/actions.js